import script from "./NumberInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./NumberInput.vue?vue&type=script&setup=true&lang=ts"

import "./NumberInput.vue?vue&type=style&index=0&id=3765a172&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3765a172"]])

export default __exports__